import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { api } from '../../utils/endpoints';
import { ApiCallsService } from './network/api-calls.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class HomeResolver implements Resolve<any> {
  constructor(
    private _apiService: ApiCallsService,
    private _userService: UserService,
  ) {}

  resolve(): Observable<any> {
    return forkJoin({
      bannerData: this._apiService.get(api._banner, {}).pipe(
        map((res: any) => res?.data?.rows || []),
        catchError((error) => {
          console.error('Error fetching banner data:', error);
          return of([]);
        }),
      ),
      userData: this._userService.getUser().pipe(
        map((user) => user || {}),
        catchError((error) => {
          console.error('Error fetching user data:', error);
          return of({});
        }),
      ),
    });
  }
}
